import { compose, lifecycle } from 'recompact';
/**
 * @deprecated Use WithInsuranceRedirect instead. Unsure if this even works and it uses an old
 * pattern.
 */
const withPharmakonRedirect = compose(
  lifecycle({
    componentDidMount() {
      const { string } = this.props.location;
      window.location.replace(`${process.env.NEXT_PUBLIC_PHARMAKON_API_URL}/v2/cc/${string}`);
    },
  })
)(() => null);

export default withPharmakonRedirect;
